import React, {useEffect, useState} from 'react'
import './scss/Menus.scss'
import {Link, NavLink} from "react-router-dom";
import path from "../../routes/path";
import {useSelector} from "react-redux";
import { admin_base_url } from '../../config/config';

const LiveSessionMenu = (props) => {
    const foundRole = useSelector((state)=>state.userReducer.currentRole);
    const [currentRole,setCurrentRole] = useState(foundRole);
    useEffect(() => {
        setCurrentRole(foundRole);
    }, [foundRole]);
    return(
        <div className={'live-session-header-menu'}>
            {currentRole==="Student"?
                <nav>
                    <ul>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.student_live_sessions}?page=1`}>Active Sessions <span></span></NavLink></li>
                        <li><NavLink to={`${process.env.PUBLIC_URL}${path.student_live_sessions_invited}?page=1`}>Invited Sessions  <span></span></NavLink></li>
                    </ul>
                </nav>
                :
                <>
            <nav>
                <ul>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.instructor_live_sessions}?page=1`}>Active Sessions <span></span></NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.instructor_live_completed}?page=1`}>Completed Sessions  <span></span></NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.instructor_live_upcoming}?page=1`}>Upcoming Sessions <span></span></NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.instructor_live_private}?page=1`}>Private Sessions <span></span></NavLink></li>
                    <li><NavLink to={`${process.env.PUBLIC_URL}${path.instructor_live_draft}?page=1`}>Draft Sessions <span></span></NavLink></li>
                </ul>
            </nav>
            <div className="right-button">
                <Link target={'_blank'} to={admin_base_url+'/add-session/'}><i className="fas fa-video"/> Add live session</Link>
            </div>
                </>
            }
        </div>
    )
}
export default LiveSessionMenu;